<template>
<form @submit.prevent="validateFields(formScope)" :data-vv-scope="formScope" class="ui large form">
	<div class="three fields" v-for="(field, index) in chunkProperty(companyFields.slice(0, 3), 3)" :key="'A' + index">
		<field :field="field[0]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[0]"/>
		<field :field="field[1]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[1]"/>
		<field :field="field[2]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[2]"/>
	</div>
	<div class="two fields" v-for="(field, index) in chunkProperty(companyFields.slice(3), 2)" :key="'B' + index">
		<field :field="field[0]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[0]"/>
		<field :field="field[1]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[1]"/>
	</div>
</form>
</template>

<script>
	import chunk from 'lodash/chunk'
	import find from 'lodash/find'

	export default {
		name: 'CompanySetup',

		data () {
			return {
				formScope: 'company-setup',

				companyFields: [],

				fieldValues: []
			}
		},

		mounted () {
			this.fetchCompanyFields(foundFields => {
				this.companyFields = foundFields
			})
		},

		methods: {
			chunkProperty (property, chunkSize) {
				return chunk(property, chunkSize)
			},

			fetchCompanyFields () {
				return new Promise((resolve, reject) => {
					var foundFields = this.$auth.user().fields.filter((currentValue, index, arary) => {
						if (currentValue.shown === 'company') {
							return currentValue
						}
					})
					this.companyFields = foundFields
					resolve(foundFields)
				})
			},

			validateFields (formScope) {
				return new Promise((resolve, reject) => {
					this.$validator.validateAll(formScope)
						.then(result => {
							if (result) {
								if (this.fieldValues.length > 0) {
									var fields = []
									// handle editableFields
									$.map(this.fieldValues, function (item, index) {
										if (item.editable) {
											if (item.required) {
												if (item.value !== '') {
													fields.push({ id: item.id, value: item.value })
												}
											} else {
												if (item.value === '') {
													fields.push({ id: item.id, value: null })
												} else {
													fields.push({ id: item.id, value: item.value })
												}
											}
										}
									})

									this.axios.put('users', {
										firstname: this.$auth.user().firstname,
										surname: this.$auth.user().surname,
										fields: fields
									})
									.then(() => {
										this.$auth.fetch()

										this.$events.$emit('alert', {
											header: this.$t('globals.validation.success.success'),
											message: this.$t('pages.setup.validation.success.company_success'),
											type: 'success',
											closebutton: true,
											align: 'right'
										})

										resolve(true)
									}).catch(() => {
										reject(false)
									})
								} else {
									resolve(true)
								}
							}
						}).catch()
				})
			},

			changeFieldValue (field) {
				if (!find(this.fieldValues, {id: field.id})) {
					this.fieldValues.push(field)
				} else {
					var arrayValue = find(this.fieldValues, {id: field.id})
					arrayValue.value = field.value
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pages/setup/CompanySetup.vue